class CacheRequest {
    requests = new Map();

    hasRequest(requestKey) {
        return this.requests.has(requestKey);
    }

    createRequest(requestKey) {
        this.requests.set(requestKey, new Map());
    }

    addRequest(requestKey, body) {
        this.requests.set(requestKey, body);
    }

    getRequest(requestKey) {
        return this.requests.get(requestKey);
    }

    getPromiseStatus(p) {
        const t = {};
        return Promise.race([p, t]).then(
            v => (v === t ? 'pending' : 'fulfilled'),
            () => 'rejected'
        );
    }

    async getData(payload, fetcher) {
        /* fetcher's name used as key of request */
        const { name: fetcherName } = fetcher;

        !this.hasRequest(fetcherName) && this.createRequest(fetcherName);
        const cachedPayloadsOfRequest = this.getRequest(fetcherName);

        const payloadKey = JSON.stringify(payload);
        const isPayloadCached = cachedPayloadsOfRequest.has(payloadKey);

        if (isPayloadCached) {
            const dataOfCurrentPayload = cachedPayloadsOfRequest.get(payloadKey);
            const status = await this.getPromiseStatus(dataOfCurrentPayload);
            if (status === 'rejected') cachedPayloadsOfRequest.delete(payloadKey);
            else return Promise.resolve(dataOfCurrentPayload);
        }
        const result = fetcher(payload);
        cachedPayloadsOfRequest.set(payloadKey, result);
        this.addRequest(fetcherName, cachedPayloadsOfRequest);
        return result;
    }
}

export const cache = new CacheRequest();
